import React from 'react';
import { Button } from '../components/Button';
import { Car } from 'lucide-react';
import { ChevronDown } from 'lucide-react';
import { Clock } from 'lucide-react';
import { Gauge } from 'lucide-react';
import { Input } from '../components/Input';
import { Link } from '../components/Link';
import { Mail } from 'lucide-react';
import { MapPin } from 'lucide-react';
import { Phone } from 'lucide-react';
import { PhoneCall } from 'lucide-react';
import { Select } from '../components/Select';
import { Sparkles } from 'lucide-react';
import { UserCheck } from 'lucide-react';
import NavBar from "../components/navigation";
import Footer from "../components/Footer";

export const ContactPage = ({ className, children, variant, contentKey, ...props }) => {
  return (
    <>
      <NavBar />
    <div className="text-text">
      
        {/* Lets Get You Behind The Wheel */}
        <section id="lets_get_you_behind_the_wheel" className="pt-32 pb-20 bg-gradient-to-br from-primary to-accent text-black">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-7xl font-heading font-bold mb-6"> Let's Get You Behind the Wheel </h1>
            <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto">
               Schedule a test drive, get in touch with our team, or visit our showroom. We're here to make your automotive dreams a reality. 
            </p>
          </div>
        </section>
        {/* Schedule Your Test Drive */}
        <section id="schedule_your_test_drive" className="py-24 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-16">
              {/* Contact Form */}
              <div>
                <h2 className="text-4xl font-heading font-bold text-dark mb-6"> Schedule Your Test Drive </h2>
                <p className="text-lg text-muted mb-8">
                   Fill out the form below and our team will reach out within 24 hours to confirm your appointment. 
                </p>
                <form className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="firstName" className="block text-sm font-bold text-text mb-2"> First Name * </label>
                      <Input className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all" type="text" id="firstName" />
                    </div>
                    <div>
                      <label htmlFor="lastName" className="block text-sm font-bold text-text mb-2"> Last Name * </label>
                      <Input className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all" type="text" id="lastName" />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-bold text-text mb-2"> Email Address * </label>
                    <Input className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all" type="email" id="email" />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-bold text-text mb-2"> Phone Number * </label>
                    <Input className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all" type="tel" id="phone" />
                  </div>
                  <div>
                    <label htmlFor="vehicle" className="block text-sm font-bold text-text mb-2"> Vehicle of Interest </label>
                    <Select className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all cursor-pointer" id="vehicle"><option> Select a vehicle </option>
                    <option> Toyota Corolla 2022 </option>
                    <option> Honda Civic 2021 </option>
                    <option> Ford Ranger 2023 </option>
                    <option> Nissan X-Trail 2020 </option>
                    <option> BMW X5 2022 </option>
                    <option> Mercedes-Benz C-Class 2021 </option>
                    <option> Audi A4 2023 </option>
                    <option> Subaru Outback 2022 </option>
                    <option> Mazda CX-5 2021 </option></Select>
                  </div>
                  <div>
                    <label htmlFor="location" className="block text-sm font-bold text-text mb-2"> Preferred Location </label>
                    <Select className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all cursor-pointer" id="location"><option> Select a location </option>
                    <option> Nairobi </option>
                    <option> Mombasa </option>
                    <option> Kisumu</option>
                    <option> Eldoret </option>
                    <option> Nakuru </option></Select>
                  </div>
                  <div>
                    <label htmlFor="testDriveType" className="block text-sm font-bold text-text mb-2"> Test Drive Type </label>
                    <Select className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all cursor-pointer" id="testDriveType"><option> Select a test drive type </option>
                    <option> Standard Test Drive (30 minutes) </option>
                    <option> Extended Test Drive (1 hour) </option>
                    <option> Off-Road Test Drive (for SUVs and 4x4s) </option></Select>
                  </div>
                    
                    
                  
                  <div>
                    <label htmlFor="preferredDate" className="block text-sm font-bold text-text mb-2"> Preferred Date </label>
                    <Input className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all" type="date" id="preferredDate" />
                  </div>
                  <div>
                    <label htmlFor="preferredTime" className="block text-sm font-bold text-text mb-2"> Preferred Time </label>
                    <Select className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all cursor-pointer" id="preferredTime"><option> Select a time </option>
                    <option> Morning (9 AM - 12 PM) </option>
                    <option> Afternoon (12 PM - 3 PM) </option>
                    <option> Evening (3 PM - 6 PM) </option></Select>
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-bold text-text mb-2"> Additional Comments </label>
                    <textarea id="message" placeholder="Let us know if you have any specific questions or requirements..." rows={4} className="w-full px-6 py-3 bg-white rounded-xl border border-border focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all resize-none"></textarea>
                  </div>
                  <div className="flex items-start gap-3">
                    <Input variant="text" className="w-5 h-5 text-primary rounded border-border focus:ring-primary mt-1 cursor-pointer" type="checkbox" id="consent" />
                    <label htmlFor="consent" className="text-sm text-muted cursor-pointer">
                       I agree to receive communications from My Car regarding my inquiry and promotional offers. You can unsubscribe at any time. 
                    </label>
                  </div>
                  <Button contentKey="cta_34" className="themed w-full px-8 py-4 bg-cta hover:bg-white hover:text-black font-bold rounded-full transition-all shadow-lg hover:shadow-orange-500/50 cursor-pointer text-white" type="submit"> Schedule Test Drive </Button>
                
                </form>
              </div>
              {/* Contact Information */}
              <div className="space-y-8">
                <div className="glass-card rounded-3xl p-8">
                  <h3 className="text-2xl font-heading font-bold text-dark mb-6"> Visit Our Showroom </h3>
                  <div className="space-y-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0"><MapPin className="w-6 h-6 text-primary" /></div>
                      <div>
                        <h4 className="font-bold text-dark mb-1"> Address </h4>
                        <p className="text-muted">
                           Nairobi, Kenya
                          <br />
                            123 Road 456
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0"><Phone className="w-6 h-6 text-primary" /></div>
                      <div>
                        <h4 className="font-bold text-dark mb-1"> Phone </h4>
                        <p className="text-muted">
                           0712 345 6789
                          <br />
                           0722 987 6543
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0"><Mail className="w-6 h-6 text-primary" /></div>
                      <div>
                        <h4 className="font-bold text-dark mb-1"> Email </h4>
                        <p className="text-muted">
                           info@mycarapp.co.ke 
                          <br />
                           sales@mycarapp.co.ke 
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0"><Clock className="w-6 h-6 text-primary" /></div>
                      <div>
                        <h4 className="font-bold text-dark mb-1"> Hours </h4>
                        <p className="text-muted">
                           Monday - Friday: 9 AM - 7 PM 
                          <br />
                           Saturday: 9 AM - 6 PM 
                          <br />
                           Sunday: 10 AM - 5 PM 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Map Placeholder */}
                <div className="glass-card rounded-3xl overflow-hidden h-80">
                  <iframe allowfullscreen="" height="100%" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.7315612763387!2d-118.26652368478853!3d34.04096908060642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c63f5f0b3f8b%3A0x3d0b0e9e8c8f0e0e!2sDowntown%20Los%20Angeles%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890123" style={{ border: "0" }} width="100%"></iframe>
                </div>
                {/* Quick Actions */}
                <div className="grid md:grid-cols-2 gap-4">
                  <Link contentKey="cta_35" className="glass-card rounded-2xl p-6 text-center hover:bg-primary hover:text-black transition-all cursor-pointer group" href="tel:3235552739"><PhoneCall className="w-8 h-8 text-primary group-hover:text-black mx-auto mb-3" />
                  <h4 className="font-heading font-bold"> Call Us Now </h4></Link>
                  <Link contentKey="cta_36" className="glass-card rounded-2xl p-6 text-center hover:bg-primary hover:text-black transition-all cursor-pointer group" href="/inventory"><Car className="w-8 h-8 text-primary group-hover:text-black mx-auto mb-3" />
                  <h4 className="font-heading font-bold"> Browse Inventory </h4></Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* What To Expect */}
        <section id="what_to_expect" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h2 className="text-4xl font-heading font-bold text-dark text-center mb-12"> What to Expect </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6"><UserCheck className="w-8 h-8 text-black" /></div>
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> No Pressure Experience </h3>
                <p className="text-muted">
                   Take your time, ask questions, and experience the vehicle at your own pace. Our team is here to guide, not push. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6"><Gauge className="w-8 h-8 text-black" /></div>
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> Real-World Testing </h3>
                <p className="text-muted">
                   Test on highways, city streets, and back roads. We want you to experience the full capabilities of your potential vehicle. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6"><Sparkles className="w-8 h-8 text-black" /></div>
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> Expert Guidance </h3>
                <p className="text-muted">
                   Our specialists provide insights on features, performance, and how the vehicle fits your lifestyle and needs. 
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Frequently Asked Questions */}
        <section id="frequently_asked_questions" className="py-24 bg-background">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h2 className="text-4xl font-heading font-bold text-dark text-center mb-12"> Frequently Asked Questions </h2>
            <div className="space-y-4">
              <details className="glass-card rounded-2xl p-6 cursor-pointer group">
                <summary className="font-bold text-dark flex items-center justify-between cursor-pointer">
                   Do I need an appointment for a test drive? 
                  <ChevronDown className="w-5 h-5 text-primary group-open:rotate-180 transition-transform" />
                </summary>
                <p className="text-muted mt-4 leading-relaxed">
                   While walk-ins are welcome, we recommend scheduling an appointment to ensure the vehicle you're interested in is available and our team is prepared to give you their full attention. 
                </p>
              </details>
              <details className="glass-card rounded-2xl p-6 cursor-pointer group">
                <summary className="font-bold text-dark flex items-center justify-between cursor-pointer">
                   What do I need to bring for a test drive? 
                  <ChevronDown className="w-5 h-5 text-primary group-open:rotate-180 transition-transform" />
                </summary>
                <p className="text-muted mt-4 leading-relaxed">
                   Please bring a valid driver's license. We may also ask for proof of insurance. If you're interested in financing, bringing recent pay stubs or tax returns can help expedite the process. 
                </p>
              </details>
              <details className="glass-card rounded-2xl p-6 cursor-pointer group">
                <summary className="font-bold text-dark flex items-center justify-between cursor-pointer">
                   How long does a test drive typically take? 
                  <ChevronDown className="w-5 h-5 text-primary group-open:rotate-180 transition-transform" />
                </summary>
                <p className="text-muted mt-4 leading-relaxed">
                   Plan for 30-45 minutes. This includes vehicle overview, road testing, and time for questions. If you'd like to test multiple vehicles, we recommend allocating additional time. 
                </p>
              </details>
              <details className="glass-card rounded-2xl p-6 cursor-pointer group">
                <summary className="font-bold text-dark flex items-center justify-between cursor-pointer">
                   Can I test drive multiple vehicles? 
                  <ChevronDown className="w-5 h-5 text-primary group-open:rotate-180 transition-transform" />
                </summary>
                <p className="text-muted mt-4 leading-relaxed">
                   Absolutely! We encourage comparing multiple vehicles to find the perfect match. Let us know your preferences and we'll arrange test drives for your top choices. 
                </p>
              </details>
            </div>
          </div>
        </section>
        {/* Footer */}
       
      
    </div>
    <Footer />
    </>
  );
};

